import moment from 'moment'
import axiosIns from '@/libs/axios'

const ROOT_URL = '/reports/current_status'
export default {
  namespaced: true,
  state: {
    reportData: {
      counters: {
        payments: null,
        pending: null,
        latePayment: null,
        customers: null,
        customerUsers: null,
        users: null,
      },
      charts: {
        userPayments: {
          labels: [],
          series: [],
        },
      },
      dataList: {
        userPayments: [],
        latestPayments: [],
        latePayments: [],
        pendingPayments: [],
      },
    },
    reportParams: {
      sdate: moment().startOf('month').format('YYYY-MM-DD'),
      edate: moment().endOf('month').format('YYYY-MM-DD'),
    },
    loading: false,
  },
  getters: {
    reportData(state) {
      return state.reportData
    },
    reportParams(state) {
      return state.reportParams
    },
    loading(state) {
      return state.loading
    },
  },
  mutations: {
    SET_DATA(state, data) {
      state.reportData = data
    },
    SET_LOADING(state, data) {
      state.loading = data
    },
  },
  actions: {
    getData({ commit }, params) {
      commit('SET_LOADING', true)
      axiosIns
        .post(ROOT_URL, params)
        .then(response => {
          commit('SET_DATA', response.data.data)
          commit('SET_LOADING', false)
        })
        .catch(error => console.error(error))
    },
  },
}
